import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import QuoteForm from "@/components/QuoteForm";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import useLenis from "@/lib/smooth";

export default function Home() {
  useLenis();
  return (
    <div className="relative bg-[#050505] text-[#F4F4F5]" data-testid="home-page">
      <div className="grain" aria-hidden />
      <Nav />
      <main>
        <Hero />
        <Services />
        <EditorialMarquee />
        <Manifesto />
        <QuoteForm />
        <ContactSection />
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
}
